module.exports = __webpack_public_path__ + "img/Video-Icon.1c0c5472.svg";